export const languageOptions = [
    { value: 'English', label: 'English' },
    { value: 'Hindi', label: 'Hindi' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'French', label: 'French' },
    { value: 'Bengali', label: 'Bengali' },
    { value: 'Russian', label: 'Russian' },
    { value: 'Portugese', label: 'Portugese' },
    { value: 'Urdu', label: 'Urdu' },
    { value: 'German', label: 'German' },
    { value: 'Marathi', label: 'Marathi' },
    { value: 'Punjabi', label: 'Punjabi' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Gujrati', label: 'Gujrati' },
    { value: 'Persian', label: 'Persian' },
    { value: 'Bhojpuri', label: 'Bhojpuri' },
    { value: 'Polish', label: 'Polish' },
    { value: 'Odia', label: 'Odia' },
    { value: 'Maithili', label: 'Maithili' },
    { value: 'Ukranian', label: 'Ukranian' },
    { value: 'Nigerian Pidgin', label: 'Nigerian Pidgin' },
    { value: 'Sindhi', label: 'Sindhi' },
    { value: 'Nepali', label: 'Nepali' },
    { value: 'Romanian', label: 'Romanian' },
    { value: 'Dutch', label: 'Dutch' },
    { value: 'Pashto', label: 'Pashto' },
    { value: 'Magahi', label: 'Magahi' },
    { value: 'Saraiki', label: 'Saraiki' },
    { value: 'Afrikaans', label: 'Afrikaans' },
    { value: 'Sinhala', label: 'Sinhala' },
    { value: 'Chattisgarhi', label: 'Chattisgarhi' },
    { value: 'Assamese', label: 'Assamese' },
    { value: 'Kurdish', label: 'Kurdish' },
    { value: 'Bavarian', label: 'Bavarian' },
    { value: 'Czech', label: 'Czech' },
    { value: 'Greek', label: 'Greek' },
    { value: 'Chittagonian', label: 'Chittagonian' },
    { value: 'Swedish', label: 'Swedish' },
    { value: 'Deccan', label: 'Deccan' },
    { value: 'Sadri', label: 'Sadri' },
    { value: 'Sylheti', label: 'Sylheti' },
    { value: 'Mandarin', label: 'Mandarin' },
    { value: 'Burmese', label: 'Burmese' },
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Somali', label: 'Somali' },
    { value: 'Indonesian', label: 'Indonesian' },
    { value: 'Vietnamese', label: 'Vietnamese' },
    { value: 'Filipino', label: 'Filipino' },
    { value: 'Japanese', label: 'Japanese' },
    { value: 'Telugu', label: 'Telugu' },
    { value: 'Tamil', label: 'Tamil' },
    { value: 'Kannada', label: 'Kannada' },
    { value: 'Malayalam', label: 'Malayalam' },
    { value: 'Turkish', label: 'Turkish' },
    { value: 'Korean', label: 'Korean' },
    { value: 'Thai', label: 'Thai' },
    { value: 'Hungarian', label: 'Hungarian' },
    { value: 'Kazakh', label: 'Kazakh' },
    { value: 'Zulu', label: 'Zulu' },
    { value: 'Malay', label: 'Malay' },
    { value: 'Ahmaric', label: 'Ahmaric' },

  ];